import React from 'react'
import { Router, Route, IndexRoute } from 'react-router'
import App from './components/app'
import startWindow from './components/startWindow/view'
import thankyouWindow from './components/thankyouWindow/view'

const Routes = (props) => (
  <Router {...props}>
    <Route path="/(:gameId)" component={App}>
      <IndexRoute component={startWindow} />
      <Route path="thankyou" component={thankyouWindow} />
    </Route>
  </Router>
)

export default Routes



// WEBPACK FOOTER //
// ./src/routes.js